import { apiMongo } from "../api/apiData";

type NewsletterUserData = {
  userFirstName?: string;
  userEmail: string;
};

export const subscribeToNewsletter = async (
  userData: NewsletterUserData,
  ip: string
) => {
  try {
    const response = await apiMongo.post("/newsletter/subscribe", {
      userFirstName: userData.userFirstName,
      userEmail: userData.userEmail,
      ip,
    });
    return response.data;
  } catch (error) {
    console.error("Błąd przy zapisie do newslettera", error);
  }
};
